<template>
  <div>
    <van-sticky >
    <van-nav-bar title="帖子详情" left-arrow  @click-left="goBack"  >
<!--      <van-button slot="right" plain   icon="good-job-o" color="#4bb0ff"-->
<!--                  style="margin-right: 5px" :class="topic.iagree?'agree':''"-->
<!--                  size="small" round-->
<!--                  @click="setAgree">-->
<!--        赞 ({{topic.agreeCount}})-->
<!--      </van-button>-->
<!--      <van-button slot="right" plain icon="comment-o" color="#4bb0ff" size="small" round @click="addPost()"> 评论 </van-button>-->
    </van-nav-bar>
    </van-sticky>

    <div style="width:100%;position: fixed;bottom: 0px;z-index: 999;background-color: #1d2d43;border:0px solid #2c4148;border-top-width:1px;padding: 8px">

      <van-button  plain b color="#eeeeee" size="small" style="width: 75%;background-color: #2a405c;border: 0px;text-align: left;padding-left: 10px" round @click="addPost()"> 写评论 </van-button>

      <span style="width: 25%;text-align: center;display: inline-block">
        <span class="wcc-icon wcc-icon-agree" @click="setAgree"
              style="font-size:12px;border-radius: 999px;color:#43b292;border: 1px solid #43b292;padding: 0 10px;line-height: 18px;height: 18px"
              :class="topic.iagree?'agree':''"> {{topic.agreeCount}}</span>
<!--        <van-button  plain   icon="good-job-o" color="#43b292"-->
<!--                    style=" border-color: #43b292;background-color: transparent;line-height: 20px;height: 22px"-->
<!--                     :class="topic.iagree?'agree':''"-->
<!--                    size="small" round-->
<!--                    @click="setAgree">-->
<!--           {{topic.agreeCount}}-->
<!--        </van-button>-->
      </span>

    </div>

    <van-panel
            :title="topic.title" :desc='moment(topic.ctime).format("YYYY-MM-DD HH:mm")'  >

        <Nick  text="楼主" :uid="topic.uid"></Nick>
<!--      <van-cell>-->
<!--          <van-image slot="icon" round-->
<!--                     width="25"-->
<!--                     height="25"-->
<!--                     src="https://img.yzcdn.cn/vant/cat.jpeg"-->
<!--          />-->
<!--          <span slot="title" style="display:inline-block;color:#8197b3;font-size: 14px;height: 25px;line-height: 25px;margin-left: 5px"> < {{topic.uid}}</span>-->

<!--        <span slot="right-icon" style="color:#8197b3;font-size: 12px ">楼主</span>-->
<!--      </van-cell>-->

      <div v-html="topic.content.replace(/\n/g,'<br>')" style="padding: 20px;font-size:14px;color: #8197b3" @click="contentClick"></div>

<!--      编辑和删除-->
      <div style="text-align: right;padding: 0 10px">
        <span v-if="topic.lastEditTime" style="font-size:11px;margin-right: 5px;color: #8197b3" >
          已在{{moment(topic.lastEditTime).fromNow()}}编辑过</span>

        <span v-if="topic.editable" class="wcc-icon wcc-icon-modify" @click="showEditTopic=true"
              style="margin-right:10px;font-size:11px;border-radius: 999px;color:#43b292;border: 1px solid #43b292;padding: 0 10px;line-height: 18px;height: 18px"
              > 编辑</span>
        <span v-if="topic.deletable" class="wcc-icon wcc-icon-del" @click="delTopic"
              style="font-size:11px;border-radius: 999px;color:#43b292;border: 1px solid #43b292;padding: 0 10px;line-height: 18px;height: 18px"
        > 删除</span>

        <!--        <van-button v-if="topic.editable" @click="showEditTopic=true"-->
<!--                plain type="default" size="small" round icon="edit"-->
<!--                style="margin-right: 5px">-->
<!--        </van-button>-->
<!--        <van-button v-if="topic.deletable" @click="delTopic"-->
<!--                plain type="default" size="small" round icon="delete"-->
<!--                style="margin-right: 5px">-->
<!--        </van-button>-->
      </div>
<!--      <van-sticky >-->
<!--        <div style="text-align: center;width: 100%;padding:10px 0"  >-->
<!--          <van-button icon="arrow-left" class="sticky_close" style="float: left" @click="goBack"></van-button>-->


<!--          <van-button plain type="default" icon="good-job-o" color="#4bb0ff"-->
<!--                      style="margin-right: 10px" :class="topic.iagree?'agree':''"-->
<!--                      @click="setAgree">-->
<!--            赞 ({{topic.agreeCount}})-->
<!--          </van-button>-->

<!--          <van-button plain type="default" round  color="#4bb0ff" icon="comment-o" @click="addPost()">评论</van-button>-->
<!--        </div>-->
<!--      </van-sticky>-->

      <van-divider :style="{  borderColor: '#2a405c',marginBottom:'0px'}" style="font-size: 12px" >评论列表 ({{topic.postCount}}/{{posts.length}})</van-divider>

      <van-list v-model="loading" :offset="30"  style="margin-bottom: 45px"
                :finished="finished"

                @load="listPost" >
        <PostItem v-for="item,index in posts" :pid="item.pid" :total="total" :index="index"
                  @addPost="addPost(item.pid)" @setAgree="setAgree"
                  @deleted="refresh"  @showEdit="startEditPost"
                  @contentClick="contentClick"/>
      </van-list>

    </van-panel>



    <van-popup v-model="showAddPost" position="bottom"   round>
      <AddPostView :mid="tid" :refPid="addPostRefId" @close="showAddPost=false"  @closeBack="postAdded"></AddPostView>
    </van-popup>


    <van-popup v-model="showEditTopic" position="bottom"  round style="height:85%">
      <EditTopic :topic="Object.assign({},topic)" @close="showEditTopic=false" @editOk="editTopicOk"></EditTopic>
    </van-popup>

    <van-popup v-model="showEditPost" position="bottom"  round>
      <EditPost :postItem="editPostItem" @close="showEditPost=false" @editOk="editPostOk"></EditPost>
    </van-popup>

    <van-image-preview
            v-model="showImg"
            :images="images"
            :showIndex="false"
    >
    </van-image-preview>
  </div>
</template>

<script>
// @ is an alias to /src
import AddPostView from "../components/addPost.vue";
import PostItem from "../components/Post.vue"
import EditTopic from "../components/editTopic.vue";
import EditPost from "../components/editPost.vue";
import Nick from "../components/nickAndAvatar"

export default {
  name: 'topic',
  components: {
    AddPostView,PostItem,EditTopic,EditPost,Nick
  },
  props:['tid'],
  data:function(){
    return {
      loading:false,
      topic:{uid:'',title:'',content:''},
      posts:[],
      total:0,
      start:0,
      len:10,
      finished:false,
      showAddPost:false,

      addPostRefId: '',
      addPostMid:'',

      isFixed:false,

      showImg:false,
      images:[],

      showEditTopic:false,
      showEditPost:false,
      editPostItem:{},
    }
  },
  methods:{
    goBack:function(){
      this.$router.push("/");
    },
    contentClick:function(event){

      console.log(event);

      var el = event.srcElement;

      if(el.tagName=="IMG"){
        this.images.splice(0);
        this.images.push(el.src);
        this.showImg = true;
      }
    },
    getTopic:function(){
        var app = this;
        app.axios.post("/bbsApi/getTopic",{
          tid:app.tid
        })
                .then(function(res){
                    console.log('getTopic',res.data)
                  if(res.data.errcode=='suc'){
                    var topic = res.data.data.topic;
                    if(!topic){
                        app.$toast({
                            type:'fail',
                            message:"帖子不见了",
                            duration:3000,
                            onClose:function(){
                                app.goBack();
                            }})

                    }
                    else{
                        app.topic = topic;
                    }
                  }
                  else{
                      app.$toast({
                          type:'fail',
                          message:"帖子不见了",
                          duration:3000,
                          onClose:function(){
                              app.goBack();
                          }})
                  }
                })
    },
    delTopic: function () {
      var app = this;
        if(!app.checkLogin()){
            return;
        }
      app.axios.post("/bbsApi/delTopic", {
        tid: app.tid
      })
              .then(function (res) {
                if (res.data.errcode == 'suc') {
                  app.goBack();
                }
              })
    },
    refresh:function(){
      this.start=0;
      this.len=10;
      this.posts.splice(0);
      this.getTopic();
      this.listPost();
    },
    listPost:function(){
      var app = this;
      app.axios.post("/bbsApi/listPost",{
        mid:app.tid,
        start:app.start,
        len:app.len
      })
              .then(function(res){

                if(res.data.errcode=='suc'){


                  if(app.start==0){
                    console.log("替换")
                    app.posts.splice(0);
                    app.posts = res.data.data.list;
                  }
                  else{
                    app.posts = [].concat(app.posts,res.data.data.list);
                    console.log("凭借",app.posts.length);
                  }

                  app.total = res.data.data.total;
                  app.len = res.data.data.len;
                  app.start = res.data.data.start + app.len;

                  console.log("next start",app.start,app.total)
                  if(app.start < app.total){
                    app.finished = false
                  }
                  else{
                    app.finished = true;
                  }

                }
                else{
                    app.total = 0;
                    app.len = 10;
                    app.start = 0;
                    app.finished = true;
                }

                app.loading = false;
              })
    },
      checkLogin:function(){
        var app = this;
          console.log("检查登录");
          if(!app.$cookie.get("session")){
              if(window.JSInterface) {
                  window.JSInterface.callMethod('login', null);
              }
              return false;
          }
          return true;
      },
    setAgree:function(){
      var app = this;

      if(!app.checkLogin()){
          return;
      }

      app.axios.post("/bbsApi/setAgree",{
          tid:app.tid,
          agree:app.topic.iagree?"cancel":"agree"
      })
              .then(function(res) {
                if (res.data.errcode == 'suc' ) {
                  app.getTopic();
                }
              })

    },
    postAdded:function(newPid){
      // this.getTopic();
      // this.posts.push({pid:newPid});

      this.refresh();
      this.showAddPost = false;
    },
    addPost:function(postRefId){
      var app = this;
        if(!app.checkLogin()){
            return;
        }

        app.axios.get("/bbsApi/checkPhone")
            .then(function(){
                app.addPostRefId = postRefId;
                app.showAddPost = true;
            })
            .catch(function(){

            })
    },

    editTopicOk:function(){
      this.showEditTopic = false;
      this.getTopic();
    },

    startEditPost:function(postItem){
      var app = this;
        if(!app.checkLogin()){
            return;
        }
        app.showEditPost = true;
        app.editPostItem = Object.assign({},postItem);
    },

    editPostOk:function(){
      this.showEditPost = false;
      this.editPostItem = {};
      this.refresh();
    },

    onScroll:function(scrollTop,isFixed){
      this.isFixed = isFixed;
      // console.log('onScroll',scrollTop,isFixed)
    },

  },
  mounted:function(){
    this.getTopic();
  }
}
</script>

<style>
  .van-sticky--fixed:first-child{
    background-color: #cfcfcf;
    -webkit-opacity: 0.99;
  }

  .sticky_close{
    display: none;
  }
  .van-sticky--fixed .sticky_close{
    display: inline-block;
  }

  .agree:before{
    font-family: FontAwesomeB;
  }

  .van-cell__title{
    color: #eeeeee;
  }

  a{
    color: #4bb0ff;
  }
  a:visited{
    color: #4bb0ff;
  }

</style>
